export default "__VITE_ASSET__DZPCL8wA__"